const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export const formatRelativeTime = (value, now = Date.now()) => {
  const time = new Date(value).getTime();
  if (!value || Number.isNaN(time)) return "";

  const diff = Math.max(0, now - time);
  if (diff < MINUTE) return "เมื่อสักครู่";
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)} นาทีที่แล้ว`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)} ชั่วโมงที่แล้ว`;
  if (diff < 7 * DAY) return `${Math.floor(diff / DAY)} วันที่แล้ว`;
  if (diff < 30 * DAY) return `${Math.floor(diff / (7 * DAY))} สัปดาห์ที่แล้ว`;
  if (diff < 365 * DAY) return `${Math.floor(diff / (30 * DAY))} เดือนที่แล้ว`;
  return `${Math.floor(diff / (365 * DAY))} ปีที่แล้ว`;
};

// แจ้งเตือนเก่าของใบเสนอราคาอาจไม่มี title ให้ใช้ message เป็นหัวข้อแทน
export const getNotificationText = (notification = {}) => {
  const title = String(notification.title || "").trim();
  const message = String(notification.message || "").trim();

  if (!title) return { heading: message, body: "" };
  return { heading: title, body: message };
};

// รับเฉพาะ path ภายในแอป (ขึ้นต้นด้วย "/" แต่ไม่ใช่ "//host")
export const getInternalNotificationLink = (link) => {
  const value = String(link || "").trim();
  if (!value.startsWith("/") || value.startsWith("//")) return "";
  return value;
};

const getNotificationPeriodStart = (notification = {}) => {
  const value =
    notification.periodStart ||
    notification.metadata?.periodStart ||
    notification.data?.periodStart ||
    "";
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : "";
};

// ปลดล็อกแล้วต้องพาเจ้าของไปหน้ากรอกเวลาของสัปดาห์นั้น แม้ backend ไม่ส่ง link มา
export const getNotificationLink = (notification = {}) => {
  const link = getInternalNotificationLink(notification.link);
  if (link || notification.event !== "submission_unlocked") return link;

  const periodStart = getNotificationPeriodStart(notification);
  return periodStart ? `/timesheets?week=${periodStart}` : "/timesheets";
};

export const formatBadgeCount = (count) => (count > 99 ? "99+" : String(count));

export const mergeNotificationPages = (current = [], next = []) => {
  const seen = new Set(current.map((item) => item._id));
  return [...current, ...next.filter((item) => !seen.has(item._id))];
};
